import licenseData from '@/data/driver/license.json'
export default () => {
  const { $t } = useNuxtApp()

  const listTypeDocument = [
    {
      key: 'CONTRACT',
      value: $t('labels.contract')
    },
    {
      key: 'HEALTHCHECK',
      value: $t('labels.healthCheck')
    },
    {
      key: 'OTHER',
      value: $t('labels.other')
    }
  ]

  const privacyDocument = [
    {
      key: 0,
      value: $t('labels.all')
    },
    {
      key: 1,
      value: $t('labels.internal')
    },
    {
      key: 2,
      value: $t('labels.onlyMe')
    }
  ]

  const healthResults = [
    {
      key: 0,
      value: $t('labels.failed')
    },
    {
      key: 1,
      value: $t('labels.passed')
    }
  ]

  const license = () => {
    return licenseData.map((item: { [key: string]: string }) => {
      item.keyDes = $t(item.keyDes)
      return item
    })
  }

  const getLabelDocumentType = (type: string) => {
    let result = ''
    switch (type) {
      case 'HEALTHCHECK':
        result = $t('labels.healthCheck')
        break
      case 'INSURANCE':
        result = $t('labels.insurance')
        break
      case 'CONTRACT':
        result = $t('labels.contract')
        break
      case 'OTHER':
        result = $t('labels.other')
        break
    }

    return result
  }

  return {
    listTypeDocument,
    privacyDocument,
    healthResults,
    license,
    getLabelDocumentType
  }
}
